module.exports = __webpack_public_path__ + "static/img/6c820ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/qhRecommendOpenAccount/images/ios.png
// module id = 674
// module chunks = 2